import React from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import "./kaleidoskopeExperience.css"

const KaleidoskopeExperience = () => {

    const { unityProvider, isLoaded, loadingProgression, requestFullscreen } = useUnityContext({
        loaderUrl: "/build/webgl/kaleidoskop.loader.js",
        dataUrl: "/build/webgl/3371fee9adfa174e2f2efe1d4c9858da.data.unityweb",
        frameworkUrl: "/build/webgl/4af7beeaa2cb05e90c5aedc9b414f539.js.unityweb",
        codeUrl: "/build/webgl/8b5905a6fbaec54566c4c6c0aba838c9.wasm.unityweb",
        streamingAssetsUrl: "/StreamingAssets",
    });

    // We'll round the loading progression to a whole number to represent the
    // percentage of the Unity Application that has loaded.
    const loadingPercentage = Math.round(loadingProgression * 100);
    function handleClickEnterFullscreen() {
        requestFullscreen(true);
    }
    return (


        <div className="canvas_unity">
            <div className="unity_container">
                {isLoaded === false && (
                    // We'll conditionally render the loading overlay if the Unity
                    // Application is not loaded.
                    <div className="loading-overlay">
                        <h1>Loading... ({loadingPercentage}%)</h1>
                        {/* <p>Loading... ({loadingPercentage}%)</p> */}
                    </div>
                )}


                <Unity className="unity" unityProvider={unityProvider} />




            </div>
            <div className="maximize_unity" onClick={handleClickEnterFullscreen}>
                <div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 0C12.4477 0 12 0.447715 12 1C12 1.55228 12.4477 2 13 2H16.5858L11.2929 7.29289C10.9024 7.68342 10.9024 8.31658 11.2929 8.70711C11.6834 9.09763 12.3166 9.09763 12.7071 8.70711L18 3.41421V7C18 7.55228 18.4477 8 19 8C19.5523 8 20 7.55228 20 7V1C20 0.447715 19.5523 0 19 0H13Z" fill="#2D3648" />
                        <path d="M2 13C2 12.4477 1.55228 12 1 12C0.447715 12 0 12.4477 0 13V19C0 19.5523 0.447715 20 1 20H7C7.55228 20 8 19.5523 8 19C8 18.4477 7.55228 18 7 18H3.41421L8.70711 12.7071C9.09763 12.3166 9.09763 11.6834 8.70711 11.2929C8.31658 10.9024 7.68342 10.9024 7.29289 11.2929L2 16.5858V13Z" fill="#2D3648" />
                    </svg>
                </div>

            </div>



        </div>



    )
}

export default KaleidoskopeExperience